import { render, staticRenderFns } from "./my-bill-detail.vue?vue&type=template&id=55184787"
import script from "./my-bill-detail.vue?vue&type=script&lang=js"
export * from "./my-bill-detail.vue?vue&type=script&lang=js"
import style0 from "./my-bill-detail.vue?vue&type=style&index=0&id=55184787&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports